import { html } from 'lit';
const Eraser =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14.806 4.95a1.23 1.23 0 0 0-.873.362L12.36 6.885l5.954 5.956 1.575-1.575a1.234 1.234 0 0 0 0-1.745l-4.21-4.209a1.24 1.24 0 0 0-.873-.362m2.448 8.952-5.955-5.956-7.188 7.188a1.235 1.235 0 0 0 0 1.745l1.524 1.524c.231.23.546.36.873.36h5.883zm-2.741 4.862h5.113a.75.75 0 0 1 0 1.5H6.508c-.725 0-1.42-.288-1.933-.8L3.05 17.94a2.734 2.734 0 0 1 0-3.867l9.82-9.821a2.734 2.734 0 0 1 3.87 0l4.208 4.208a2.734 2.734 0 0 1 0 3.867z" clip-rule="evenodd"/>
  </svg>
`;
export default Eraser;
